import { render } from "./MainContent.vue?vue&type=template&id=2b5a73c3&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=2b5a73c3&scoped=true&lang=css"

import exportComponent from "/Users/giacomo/Developer/tandu/barbera/barberabilance-docs-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5a73c3"]])

export default __exports__